export enum RevenueCatPlacement {
  ONBOARDING_PARENT = 'onboarding_parent',
  PAYWALL_PANEL = 'paywall_panel',
  WEB_ONBOARDING_PARENT = 'web_onboarding_parent',
}

export const MONTHLY_ENTITLEMENT_ID = 'premium';
export const MONTHLY_ENTITLEMENT_ID_WITHOUT_TRIAL = 'premium_without_trial';
export const SEMI_ANNUAL_ENTITLEMENT_ID = 'premium_semi_annual';
export const ANNUAL_ENTITLEMENT_ID = 'premium_annual';
export const ANNUAL_ENTITLEMENT_ID_WITHOUT_TRIAL =
  'premium_annual_without_trial';
export const ANNUAL_INSTALLMENTS_ENTITLEMENT_ID = 'premium_annual_installments';
